<template>
  <div>
    <v-container>
      <v-btn
        class="ml-0"
        depressed
        @click="graphtype = 'campaign'"
        :outline="graphtype != 'campaign'"
        :color="graphtype == 'campaign' ? 'primary' : 'grey'"
      >
        {{ $t('Campaign') }}
      </v-btn>
      <v-btn
        depressed
        @click="graphtype = 'user'"
        :outline="graphtype != 'user'"
        :color="graphtype == 'user' ? 'primary' : 'grey'"
      >
        {{ $t('User') }}
      </v-btn>
    </v-container>
    <v-divider />
    <v-container>
      <date-filter
        ref="datefilter"
        v-model="selectedDate"
        @changeDate="onDateChanged"
        :default-filter="'last_7_days'"
      ></date-filter>
      <stat-card class="my-2" v-model="total_all_user" :loading="loading">
        {{ $t('total unique user') }}
      </stat-card>
      <h3 class="mt-2">{{ $t('Select BeaconID') }}</h3>
      <multiselect
        class="mb-2"
        id="ajax"
        v-model="beaconSelect"
        :options="items"
        :loading="isLoading"
        :show-no-results="true"
        :placeholder="$t('Beacon')"
        label="name"
        track-by="name"
        @select="onDateChanged"
      >
      </multiselect>
      <template v-if="graphtype == 'campaign'">
        <report-message-list
          :key="`report-user-by-date_${timestamp}`"
          :date="selectedDate"
          v-model="total_all_user"
          :beaconSelect="beaconSelect"
        >
        </report-message-list>
      </template>
      <template v-if="graphtype == 'user'">
        <report-user-by-date
          :key="`report-user-by-date_${timestamp}`"
          :date="selectedDate"
          v-model="total_all_user"
          :beaconSelect="beaconSelect"
        ></report-user-by-date>

        <report-user-by-time
          :key="`report-user-by-time_${timestamp}`"
          :date="selectedDate"
          v-model="dataExportTime"
          :beaconSelect="beaconSelect"
        ></report-user-by-time>
      </template>
    </v-container>
    <!-- <report-conversation :type="'comment'"></report-conversation> -->
  </div>
</template>

<script>
// import ReportConversation from '../../view/analytics/ReportConversation.vue'
import ReportUserByDate from './ReportUserByDate'
import ReportUserByTime from './ReportUserByTime'
import ReportMessageList from './ReportMessageList'
import DateFilter from '../analytics/DateFilter.vue'
import Multiselect from 'vue-multiselect'
import dayjs from 'dayjs'
import api from '@/api'
import { mapGetters } from 'vuex'
import StatCard from '../analytics/StatCard'
export default {
  components: {
    // ReportConversation,
    DateFilter,
    ReportUserByDate,
    ReportUserByTime,
    ReportMessageList,
    Multiselect,
    StatCard
  },
  data() {
    return {
      total_all_user: 0,
      loading: false,
      beaconSelect: null,
      isLoading: false,
      items: [],
      timestamp: dayjs().format('x'),
      dataExportTime: null,
      dataExportDate: null,
      graphtype: 'campaign',
      selectedDate: {
        end: dayjs().format('YYYY-MM-DD'),
        start: dayjs()
          .subtract(7, 'days')
          .format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.getBeaconsList(50,0)
  },
  methods: {
    onDateChanged() {
      this.timestamp = dayjs().format('x')
    },
    async reportMessageBeaconsList() {
      var res = await api.reportMessageBeaconsList({
        pageid: this.selectedBot.pageid,
        params: { from_date: this.selectedDate.start, to_date: this.selectedDate.end }
      })
      if (res.success) {
        console.log(res.result)
      }
    },
    async getBeaconsList(limit, offset) {
      this.isLoading = true
      var res = await api.getBeaconsList({
        pageid: this.selectedBot.pageid,
        limit: limit,
        offset: offset
      })
      if (res.success) {
        this.items = res.result
        this.beaconSelect = this.items[0]
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/beacon/Analytics.vue